module.exports = __webpack_public_path__ + "assets/images/monkey-son-banana_9ae8bc851075c6017fff7dc3f645d857.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/stages/stage-three/monkey-son-banana.png
// module id = 304
// module chunks = 0